import { render, staticRenderFns } from "./AngleUpIcon.vue?vue&type=template&id=e7f332ca&"
import script from "./AngleUpIcon.vue?vue&type=script&lang=js&"
export * from "./AngleUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports